__turbopack_context__.v({
  "footer": "FooterSocial-module__wCg13a__footer",
  "inner": "FooterSocial-module__wCg13a__inner",
  "links": "FooterSocial-module__wCg13a__links",
});
